import {
  getAllDeliveryMethods,
  newDeliveryMethod,
  updateDeliveryMethod,
  deleteDeliveryMethod,
  getDeliveryMethod,
} from '../../services/delivery_mehods';

export default {
  /**
   * Get all delivery methods
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllDeliveryMethods({ commit }, { page = null, limit = null }) {
    const response = await getAllDeliveryMethods(page, limit);
    const pagination = {
      lastPage: response.pagination.lastPage,
      page: response.pagination.page,
      perPage: response.pagination.perPage,
      total: Number(response.pagination.total),
    };
    commit('setProperty', { property: 'delivery_methods', payload: response.data });
    commit('setProperty', { property: 'pagination', payload: pagination });
  },

  /**
   *
   * @param commit
   * @param deliveryMethodId
   * @returns {Promise<void>}
   */
  async deleteDeliveryMethod({ commit }, { deliveryMethodId }) {
    await deleteDeliveryMethod(deliveryMethodId);
    commit('delProperty', { property: deliveryMethodId });
  },

  /**
   *
   * @param context
   * @param deliveryMethodId
   * @param delivery_method
   * @returns {Promise<void>}
   */
  async updateDeliveryMethod(context, { deliveryMethodId, delivery_method }) {
    await updateDeliveryMethod(deliveryMethodId, delivery_method);
  },

  /**
   *
   * @param context
   * @param delivery_method
   * @returns {Promise<void>}
   */
  async newDeliveryMethod({ commit }, { delivery_method }) {
    const response = await newDeliveryMethod(delivery_method);
    commit('setNewDeliveryMethod', { payload: response });
    commit('setProperty', { property: 'delivery_method', payload: response });
  },

  /**
   *
   * @param context
   * @param deliveryMethodId
   * @returns {Promise<void>}
   */
  async getDeliveryMethod({ commit }, deliveryMethodId) {
    const response = await getDeliveryMethod(deliveryMethodId);
    commit('setProperty', { property: 'delivery_method', payload: response });
  },
};
